import { message } from "antd";
import {
    ingestionFailuresGet,
    ingestionFailureGetById
} from "./requests";

export const FETCH_INGESTION_FAILURES_REQUEST = "FETCH_INGESTION_FAILURES_REQUEST";
export const FETCH_INGESTION_FAILURES_SUCCESS = "FETCH_INGESTION_FAILURES_SUCCESS";
export const FETCH_INGESTION_FAILURES_FAILURE = "FETCH_INGESTION_FAILURES_FAILURE";

export const FETCH_INGESTION_FAILURE_DETAIL_REQUEST = "FETCH_INGESTION_FAILURE_DETAIL_REQUEST";
export const FETCH_INGESTION_FAILURE_DETAIL_SUCCESS = "FETCH_INGESTION_FAILURE_DETAIL_SUCCESS";
export const FETCH_INGESTION_FAILURE_DETAIL_FAILURE = "FETCH_INGESTION_FAILURE_DETAIL_FAILURE";

export const CLEAR_INGESTION_FAILURES = "CLEAR_INGESTION_FAILURES";

export const fetchIngestionFailures = (filters = {}) => async dispatch => {
    dispatch({ type: FETCH_INGESTION_FAILURES_REQUEST });
    
    try {
        const response = await ingestionFailuresGet(filters);
        dispatch({
            type: FETCH_INGESTION_FAILURES_SUCCESS,
            payload: response.data
        });
    } catch (error) {
        dispatch({ type: FETCH_INGESTION_FAILURES_FAILURE });
        message.error("Error fetching ingestion failures");
        console.error(error);
    }
};

export const fetchIngestionFailureDetail = (id) => async dispatch => {
    dispatch({ type: FETCH_INGESTION_FAILURE_DETAIL_REQUEST });
    
    try {
        const response = await ingestionFailureGetById(id);
        dispatch({
            type: FETCH_INGESTION_FAILURE_DETAIL_SUCCESS,
            payload: response.data
        });
        return response.data;
    } catch (error) {
        dispatch({ type: FETCH_INGESTION_FAILURE_DETAIL_FAILURE });
        message.error("Error fetching ingestion failure detail");
        console.error(error);
        return null;
    }
};

export const clearIngestionFailures = () => ({
    type: CLEAR_INGESTION_FAILURES
});

